import styled from 'styled-components/native';

import Text from '@components/Text';

export const Container = styled.View`
  padding: 8px;
`;

export const Content = styled.View`
  margin-top: 30px;
`;

export const Footer = styled.View`
  margin-top: 32px;
`;

export const ItemValueContainer = styled.View`
  flex-direction: column;
  flex: 1;
  text-align: right;
`;

export const Header = styled.View`
  align-items: center;

  width: 218px;
  margin: 0 auto;
`;

export const InvoiceImage = styled.Image`
  width: 90px;
  height: 90px;

  margin-bottom: 16px;
`;

export const Title = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot4};
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 12px;

  margin-bottom: 4px;
`;

export const Subtitle = styled.View`
  flex-direction: row;
`;

export const SubtitleSymbol = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot6};
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 18px;
  margin-top: 4px;
`;

export const SubtitlePrice = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot6};
  font-family: ${props => props.theme.fonts.weight[400]};
  font-size: 30px;

  margin-left: 8px;
`;

export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding-top: 16px;

  padding-bottom: ${props => props.border && '16px'};
  border-bottom-color: ${props => props.theme.colors.grayscale.slot2};
  border-bottom-width: ${props => (props.border ? '1px' : 0)};
  border-style: solid;
  border-width: 0;
`;

export const ItemTitleContainer = styled.View`
  justify-content: center;

  margin-right: 16px;
`;

export const ItemTitle = styled(Text)`
  font-size: 13px;
`;

export const ItemValue = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
  overflow: hidden;
`;

export const ItemValueSub = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot4};
  margin-top: 5px;
`;

export const FilledButton = styled.TouchableOpacity`
  padding: 16px 0px;
  background-color: ${props => props.theme.colors.base.slot1};
  width: 100%;
  height: 50px;
  text-align: center;
  border-radius: 30px;
`;

export const FilledButtonText = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot1};
  font-size: 16px;
`;
